/* global angular, $, TweenMax, Linear */
angular.module('ua5App')
    .directive('floatingTerms', ['$timeout', function($timeout) {
        return {
            restrict: 'E',
            templateUrl: 'components/floating_terms/floating_terms.html',
            scope: {
                terms: '=',
                avoidSelector: '@'
            },
            link: function($scope, $element, $attrs) {
                var $$container;
                var $$terms;
                $$container = $($element).find('.floating-terms');
                $$terms = $$container.find('.floating-terms__term');

                function arrange() {
                    $$container.arrange({
                        arrange: '.floating-terms__term',
                        slack: 10,
                        avoid: $attrs.avoidSelector
                    });
                }

                // arrange();
                // animateTerms();

                $scope.$on('app:resized', function() {
                    arrange();
                });

                $timeout(function() {

                    $scope.$watch(function() {
                        return $scope.terms;
                    }, function() {
                        TweenMax.killTweensOf($$terms);
                        $$terms = $$container.find('.floating-terms__term');
                        arrange();
                        animateTerms();
                        $$terms.on('mouseenter', function(e) {
                            stopAnimation($(e.target));
                        });
                        $$terms.on('mouseleave', function() {
                            animateTerms();
                        });
                    });
                });

                function makeNewPosition(oldq) {
                    // Get viewport dimensions (remove the dimension of the div)
                    var PADDING = 0;
                    var h;
                    var maxX;
                    var maxY;
                    var minX;
                    var minY;
                    var newX;
                    var newY;
                    var w;
                    h = $$container.height() - PADDING;
                    w = $$container.width() - PADDING;
                    maxX = w - oldq.left;
                    maxY = h - oldq.top;
                    minX = -oldq.left;
                    minY = -oldq.top;
                    newY = Math.random() * (maxY - minY) + minY;
                    newX = Math.random() * (maxX - minX) + minX;

                    return [newX, newY];
                }

                function animateTerms() {
                    angular.forEach($$terms, function(term) {
                        var $$term = $(term);
                        var oldq = $($$term).offset();
                        var newq = makeNewPosition(oldq);
                        var speed = calcSpeed([oldq.left, oldq.top], newq);
                        TweenMax.to($$term, speed / 1000, {
                            x: '+=' + newq[0],
                            y: '+=' + newq[1],
                            ease: Linear.ease,
                            onComplete: animateTerms
                        });
                    });
                }

                function calcSpeed(prev, next) {
                    var x = Math.abs(prev[0] - (prev[0] + next[0]));
                    var y = Math.abs(prev[1] - (prev[1] + next[1]));
                    var greatest = x > y ? x : y;
                    var speedModifier = 0.005;
                    var speed = Math.ceil(greatest / speedModifier);
                    return speed;
                }

                function stopAnimation($term) {
                    TweenMax.killTweensOf($term);
                }

                $scope.$on('$destroy', function() {
                    // Kill all tweens
                    TweenMax.killTweensOf($$terms);
                    // Remove listeners
                    $$terms.off();
                });
            }
        };
    }])
;
